module.exports = __webpack_public_path__ + "img/logo@3x.445a4330.png";